var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"还原文件","visible":_vm.visible,"close-on-click-modal":false,"width":"550px"},on:{"update:visible":function($event){_vm.visible=$event},"open":_vm.handleDialogOpen,"close":_vm.handleDialogClose}},[_c('div',{staticClass:"restore-text"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" 正在还原文件，请稍等片刻... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }